var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pagetop"},on:{"click":_vm.backToTop}},[_c('tk-link',[_vm._v("ページ上部へ戻る▲")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }